/* Shared total only; existing hero and product typography stays in the theme. */
(()=>{
 if(window.__fateSocialCounter)return;window.__fateSocialCounter=true;
 const endpoint='https://fate-support-api-production.up.railway.app/v1/social-counter';
 const selector='[data-fate-social-proof]';
 const format=new Intl.NumberFormat('en-US'),cacheKey='fate-social-total-v1';let total=null,busy=false;
 const valid=count=>Number.isSafeInteger(count)&&count>=100000&&count<=100000000;
 function render(next,animate){
  document.querySelectorAll(selector).forEach(container=>{
   const amount=[...container.querySelectorAll('strong')].find(el=>/^\s*\d[\d,]*\+?\s*$/.test(el.textContent));
   if(!amount)return;
   const value=format.format(next);if(amount.textContent.trim()===value)return;
   // Spaces can live INSIDE the merchant's strong tag. Replace digits only.
   const walker=document.createTreeWalker(amount,NodeFilter.SHOW_TEXT);let node;
   while((node=walker.nextNode())){if(/\d[\d,]*\+?/.test(node.data)){node.data=node.data.replace(/\d[\d,]*\+?/,value);break;}}
   if(animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&amount.animate)amount.animate([{opacity:.35},{opacity:1}],{duration:500,easing:'ease-out'});
  });
 }
 async function refresh(){
  if(document.hidden||busy||!document.querySelector(selector))return;busy=true;
  try{const res=await fetch(endpoint,{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(5000)});if(!res.ok)return;
   const {count}=await res.json();if(!valid(count)||total!==null&&count<total)return;
   render(count,total!==null&&count>total);total=count;
   try{localStorage.setItem(cacheKey,JSON.stringify({count,at:Date.now()}));}catch{}
  }catch{}finally{busy=false;}
 }
 // Paint the last confirmed total immediately on subsequent pages, then verify.
 try{const cached=JSON.parse(localStorage.getItem(cacheKey));if(valid(cached?.count)&&Number.isFinite(cached.at)&&Date.now()-cached.at>=0&&Date.now()-cached.at<86400000){total=cached.count;render(total,false);}}catch{}
 refresh();setInterval(refresh,5000);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
 document.addEventListener('shopify:section:load',()=>{if(total!==null)render(total,false);refresh();});
})();
